//export const nameof = <T>(name: keyof T) => name;
export const nameof = <T>(name: Extract<keyof T, string>): string => name;

export function DecimalRound(target: number, precision: number): number {
  const lowestFloatingPointRoundUp = 8;
  const tenTimes =
    Math.round(target * Math.pow(10, lowestFloatingPointRoundUp)) /
    Math.pow(10, lowestFloatingPointRoundUp - precision);
  return Math.round(tenTimes) / Math.pow(10, precision);
}
